/* ⚠️ GENERATED from app/services/reelsRow.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/reelsRow.ts — where the reels strip sits in the feed, and when.
//
// 🟥 A RANDOM POSITION IS NOT THE SAME THING AS A POSITION CHOSEN AT RANDOM.
//    The phone picks `Math.floor(Math.random() * (len - 2)) + 2` at the moment
//    it builds the feed — which is right there, because the feed is built once
//    and held in a ref. The browser's feed is a LIVE ARRAY: it is rebuilt every
//    time anybody likes a post, votes in a poll or scrolls another page in. A
//    position drawn inline there would be redrawn on every one of those, and
//    the strip would walk up and down the feed while you read it.
//
// 🟢 SO THE SEED IS DRAWN ONCE AND THE POSITION IS DERIVED FROM IT. Random
//    across sessions and across refreshes — which is the whole point, the strip
//    must not live in one place — and completely stable while a reader is
//    looking at it, which is the part a call to Math.random() in a render
//    cannot give you.
//
// 🟢 AND BOTH CLIENTS ASK THE SAME QUESTION. The phone had this arithmetic
//    inline; a second copy in the browser is a second set of edge cases at the
//    ends of the list, and the ends are where every off-by-one in a splice
//    lives.

/** A strip of fewer than three is a row with a hole in it, not a row. */
export const REELS_MIN = 3;

/** Never more than this many, however many the ranker offers. */
export const REELS_MAX = 10;

/**
 * 🟥 NOT AT THE TOP. The feed opens on posts, not on a shelf of somebody
 *    else's videos — a strip in the first slot reads as an ad break before the
 *    thing you came for. Two posts is enough to establish what this screen is
 *    before it offers a detour.
 */
export const REELS_MIN_INDEX = 2;

/** A fresh seed. Drawn once per feed, not once per render. */
export const newReelsSeed = () => Math.floor(Math.random() * 1e9) + 1;

/**
 * Where the strip goes in a feed of `count` posts.
 *
 * 🟥 IT MUST NOT FALL OFF EITHER END. Below `REELS_MIN_INDEX` it is an ad break;
 *    past `count` a splice silently appends, so on a short feed the strip
 *    quietly became a footer — which is exactly the "always in one place" the
 *    randomness exists to avoid, arrived at from the other direction.
 *
 * 🟢 DERIVED, NOT DRAWN. Same seed and same length, same answer — so a re-render
 *    cannot move it, and a genuinely new feed gets a genuinely new place.
 */
export function reelsRowIndex(seed, count) {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  if (n <= REELS_MIN_INDEX) return n; // shorter than the first legal slot: the end
  const span = n - REELS_MIN_INDEX + 1; // every slot from MIN_INDEX to n inclusive
  const s = Math.abs(Math.floor(Number(seed) || 0));
  return REELS_MIN_INDEX + s % span;
}

/** Is there enough here to draw a strip at all? */
export const enoughReels = items => Array.isArray(items) && items.length >= REELS_MIN;

/**
 * The feed with the strip in it.
 *
 * 🟢 A NEW ARRAY, AND THE ORIGINAL UNTOUCHED. The browser's feed is React state
 *    that other things read; splicing it in place would mutate a value another
 *    render is holding.
 *
 * 🟥 AND NOTHING IS INSERTED WHEN THERE IS NOTHING TO INSERT. An empty strip in
 *    the middle of a feed is a gap the reader has to scroll past twice.
 */
export function withReelsRow(posts, row, seed) {
  const list = Array.isArray(posts) ? posts : [];
  if (!row) return list.slice();
  const at = reelsRowIndex(seed, list.length);
  const out = list.slice();
  out.splice(at, 0, row);
  return out;
}
